const reviews = [
  {
    name: "Nguyễn Thị Hà",
    job: "Nhân viên văn phòng - Hà Nội",
    rating: 5,
    quote:
      "Tôi đăng ký vay 5 triệu để xử lý việc gia đình gấp, chỉ 10 phút sau tiền đã về tài khoản. Quy trình thực sự đơn giản, không cần đi đâu cả.",
    avatar:
      "https://readdy.ai/api/search-image?query=Friendly%20smiling%20Vietnamese%20office%20woman%20portrait%20professional%20headshot%20natural%20daylight%20soft%20cream%20background%20clean%20minimal%20composition&width=200&height=200&seq=avatar-review-01&orientation=squarish",
  },
  {
    name: "Trần Văn Long",
    job: "Tài xế công nghệ - TP.HCM",
    rating: 5,
    quote:
      "Đã vay 3 lần ở VF Money, lần nào cũng được duyệt nhanh, lãi suất rõ ràng. Đặc biệt khi trả đúng hạn còn được hoàn tiền nữa, quá đỉnh!",
    avatar:
      "https://readdy.ai/api/search-image?query=Friendly%20young%20Vietnamese%20man%20portrait%20wearing%20simple%20casual%20shirt%20warm%20natural%20daylight%20studio%20soft%20sage%20green%20background%20clean%20minimal%20composition%20genuine%20smile&width=200&height=200&seq=avatar-review-02&orientation=squarish",
  },
  {
    name: "Lê Minh Khoa",
    job: "Chủ shop online - Đà Nẵng",
    rating: 5,
    quote:
      "Hạn mức 10 triệu giúp tôi nhập thêm hàng cho dịp lễ. Hỗ trợ chăm sóc khách hàng rất nhiệt tình, trả lời nhanh kể cả buổi tối.",
    avatar:
      "https://readdy.ai/api/search-image?query=Confident%20smiling%20Vietnamese%20small%20business%20owner%20man%20portrait%20clean%20casual%20attire%20warm%20golden%20daylight%20soft%20beige%20background%20editorial%20portrait%20photography&width=200&height=200&seq=avatar-review-03&orientation=squarish",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-background-50 py-20 md:py-28 px-6 md:px-10">
      <div className="text-center max-w-3xl mx-auto mb-14">
        <p className="text-primary-600 text-sm font-semibold tracking-widest uppercase mb-4">
          Nhận xét
        </p>
        <h2 className="font-heading text-foreground-950 text-3xl md:text-5xl leading-tight">
          Khách hàng nói gì về VF Money
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {reviews.map((r, idx) => (
          <div
            key={r.name}
            className={`rounded-2xl p-7 border ${
              idx === 1
                ? "bg-primary-500 border-primary-600 text-background-50"
                : "bg-background-100 border-background-200/70"
            }`}
          >
            <div className="flex items-center gap-1 mb-4">
              {Array.from({ length: r.rating }).map((_, i) => (
                <i
                  key={i}
                  className={`ri-star-fill ${
                    idx === 1 ? "text-accent-300" : "text-accent-500"
                  }`}
                ></i>
              ))}
            </div>
            <p
              className={`text-base leading-relaxed mb-6 ${
                idx === 1 ? "text-background-50" : "text-foreground-800"
              }`}
            >
              "{r.quote}"
            </p>
            <div className="flex items-center gap-3 pt-5 border-t border-current/10">
              <img
                src={r.avatar}
                alt={r.name}
                className="w-12 h-12 rounded-full object-cover object-top"
              />
              <div>
                <p
                  className={`font-bold text-sm ${
                    idx === 1 ? "text-background-50" : "text-foreground-950"
                  }`}
                >
                  {r.name}
                </p>
                <p
                  className={`text-xs ${
                    idx === 1 ? "text-background-100/80" : "text-foreground-500"
                  }`}
                >
                  {r.job}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}